class LinearRange {
	
	constructor( min, max ) {
		this.min = new Date(min);
		this.max = new Date(max);
	}
	
	get start() {
		return this.min;
	}
	
	get end() {
		return this.max;
	}
	
	get values() {
		return [this.min, this.max]
	}	
		
}

export {
	LinearRange
}